import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoadingPage from './LoadingPage';
import SurveyPage from './SurveyPage';
import SubmitPage from './SubmitPage';
import ThankYouPage from './ThankYouPage';
import SurveyLayout from '../layouts/SurveyLayout';
import { loadOpenSurvey } from '../redux/actions';
import { useAppDispatch, useAppSelector } from '../redux/ReduxProvider';
import { OPEN_SURVEY_ROUTE, OPEN_SURVEY_SUBMIT_ROUTE, OPEN_SURVEY_THANKYOU_ROUTE } from '../constants/routes';

export type RawSurveyElement = Record<string, unknown> & { id: number; orderIndex: number };

interface OpenSurveyFlowProps {
  openSurveyExternalId: string;
  openSurveyAccessCode: string;
  survey: { id: number; name: string; questions: RawSurveyElement[] };
}

const OpenSurveyFlow = ({ openSurveyExternalId, openSurveyAccessCode, survey }: OpenSurveyFlowProps) => {
  const dispatch = useAppDispatch();
  const isLoaded = useAppSelector((state) => state.survey.openSurvey?.externalId === openSurveyExternalId);

  useEffect(() => {
    dispatch(loadOpenSurvey({ externalId: openSurveyExternalId, accessCode: openSurveyAccessCode, survey }));
    // Reloading on a survey object change would discard the respondent's answers.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, openSurveyExternalId, openSurveyAccessCode]);

  if (!isLoaded) return <LoadingPage />;

  return (
    <SurveyLayout>
      <Routes>
        <Route path="" element={<SurveyPage />} />
        <Route path={OPEN_SURVEY_SUBMIT_ROUTE.slice(OPEN_SURVEY_ROUTE.length)} element={<SubmitPage />} />
        <Route path={OPEN_SURVEY_THANKYOU_ROUTE.slice(OPEN_SURVEY_ROUTE.length)} element={<ThankYouPage />} />
      </Routes>
    </SurveyLayout>
  );
};

export default OpenSurveyFlow;
